const UNSUPPORTED_ACTION_IDS = ['suspension-state-creation-message']

export function isUnsupportedActionId(actionId?: string): boolean {
  return actionId ? UNSUPPORTED_ACTION_IDS.includes(actionId) : false
}
